import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import LSBdDisplay02 from "../../molecules/text/linSeedKr/Bd/lsBdDisplay02";
import LSRgH2HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import useDisplay from "../../../hooks/useDisplay";
import LSRgBody01 from "../../molecules/text/linSeedKr/Rg/lsRgBody01";
import LSBdH2HeadLine from "../../molecules/text/linSeedKr/Bd/lsBdH2HeadLine";
import { fileUrl } from "../../../api/api";
import { formatRatingNumber } from "../../../util/formatNumber";
import { route } from "../../../router/route";

function MyReviewItem({ data, setReviewList, setDeleteId, setIsModalOpen }) {
  const contentRef = useRef(null);
  const [isShortContent, setIsShortContent] = useState(false);

  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();
  const isSmall = isMobile || isTablet;

  useEffect(() => {
    if (contentRef.current) {
      const lineHeight = isSmall ? 19.6 : 25.2; // 각 줄의 높이(px)
      const contentHeight = contentRef.current.offsetHeight;
      const lineCount = contentHeight / lineHeight;

      setIsShortContent(lineCount <= 4);
    }
  }, [data.content, isSmall]);

  return (
    <>
      <ReviewContainer $isSmall={isSmall}>
        <ReviewHeaderWrapper>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              height: isSmall ? 20 : 34,
            }}
          >
            <img
              style={{
                width: isSmall ? 12 : 24,
                height: isSmall ? 12 : 24,
                objectFit: "cover",
                // marginBottom: 8,
              }}
              src={"/assets/icons/star_3d.png"}
              alt="별점"
            />
            <LSBdDisplay02
              style={{
                color: "#101113",
                fontSize: isSmall ? 14 : 24,
                lineHeight: isSmall ? "19.6px" : "33.6px",
              }}
            >
              {formatRatingNumber(String(data?.score || 0))}
            </LSBdDisplay02>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: isSmall ? 10 : 20,
              height: isSmall ? 18 : 24,
            }}
          >
            <img
              style={{
                width: isSmall ? 18 : 24,
                height: isSmall ? 18 : 24,
                cursor: "pointer",
                objectFit: "cover",
              }}
              src={"/assets/icons/pen.png"}
              alt="수정하기"
              onClick={() => {
                navigate(`${route.my_page_activity_review_edit}/${data.id}`);
              }}
            />
            <img
              style={{
                width: isSmall ? 18 : 24,
                height: isSmall ? 18 : 24,
                cursor: "pointer",
                objectFit: "cover",
              }}
              src={"/assets/icons/trash.png"}
              alt="삭제하기"
              onClick={() => {
                setDeleteId(data.id);
                setIsModalOpen(true);
              }}
            />
          </div>
        </ReviewHeaderWrapper>
        <LSBdDisplay02
          style={{
            color: "#101113",
            marginBottom: 20,
            maxWidth: "100%",
            fontSize: isSmall ? 16 : 24,
            lineHeight: isSmall ? "22.4px" : "33.6px",
            height: !data.isViewMore ? (isSmall ? 44 : 68) : "fit-content",
            display: !data.isViewMore && "-webkit-box",
            WebkitBoxOrient: !data.isViewMore && "vertical",
            wordBreak: !data.isViewMore && "break-word",
            overflow: !data.isViewMore && "hidden",
            WebkitLineClamp: !data.isViewMore && 2, // 2줄부터 ... 표시
          }}
        >
          {data?.title || ""}
        </LSBdDisplay02>
        <div
          style={{
            height: !data.isViewMore ? (isSmall ? 118 : 150) : "fit-content",
            marginBottom: isSmall ? "16px" : "32px",
          }}
        >
          <div
            ref={contentRef}
            style={{
              color: "#101113",
              fontSize: isSmall ? 14 : 18,
              lineHeight: isSmall ? "19.6px" : "25.2px",
              display: !data.isViewMore && "-webkit-box",
              WebkitBoxOrient: !data.isViewMore && "vertical",
              wordBreak: !data.isViewMore && "break-word",
              overflow: !data.isViewMore && "hidden",
              WebkitLineClamp: !data.isViewMore && 6,
            }}
          >
            {data.content}
          </div>
        </div>
        {/* 더보기 버튼 */}

        {isShortContent ? (
          <div
            style={{
              height: 30,
            }}
          />
        ) : (
          <ViewMoreBtn
            onClick={() => {
              setReviewList((prev) =>
                prev.map((review) =>
                  review.id === data.id
                    ? { ...review, isViewMore: !review.isViewMore }
                    : review,
                ),
              );
            }}
          >
            <LSRgBody01 style={{ color: "#898E99" }}>
              {!data.isViewMore ? "더보기" : "접기"}
            </LSRgBody01>
          </ViewMoreBtn>
        )}

        <ReviewContentWrapper>
          <ReviewContentImg
            src={
              data?.lecture?.thumbnailServerFileName
                ? `${fileUrl}/${data.lecture.thumbnailServerFileName}`
                : ""
            }
            alt="콘텐츠 썸네일 이미지"
          />
          <LSBdH2HeadLine style={{ color: "#000" }}>
            {data?.lecture?.title || ""}
          </LSBdH2HeadLine>
        </ReviewContentWrapper>
      </ReviewContainer>
    </>
  );
}

export default MyReviewItem;

const ReviewContainer = styled.div.attrs((props) => {})`
  width: ${(props) => (props.$isSmall ? "335px" : "483px")};
  min-height: ${(props) => (props.$isSmall ? "325px" : "532px")};
  display: flex;
  flex-direction: column;
  border-radius: 15px;
  padding: ${(props) => (props.$isSmall ? "30px" : "48px 40px")};
  background-color: #f6f7f8;
  align-self: baseline;
`;

const ReviewHeaderWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const ViewMoreBtn = styled.button.attrs((props) => {})`
  display: flex;
  align-self: flex-end;
  justify-content: center;
  align-items: center;
  height: fit-content;
  width: fit-content;
  padding: 4px 0px;
  border-bottom: 1px solid #898e99;
  cursor: pointer;
`;

const ReviewContentWrapper = styled(LSRgH2HeadLine)`
  display: flex;
  align-items: center;
  width: 100%;
  height: fit-content;
  margin-top: 16px;
  gap: 16px;
`;

const ReviewContentImg = styled.img.attrs((props) => {})`
  width: 113px;
  height: 72px;
  object-fit: cover;
  border-radius: 8px;
`;
